import { FC } from 'react';
import { Login } from './Login/Login';

export const LoginPage: FC = () => {
  return <Login />;
};
